export default {
    inject: ["memberSvc", "reportSvc"],
    data() {
        return {
            members: [],
        }
    },
    computed: {
        memberIds() {
            return this.members.map((item) => item.id)
        },
    },
    methods: {
        encodeReportID(id, companyID = null) {
            const encodeStr = companyID
                ? `${id}:company-${companyID}`
                : `${id}:report-id`

            return btoa(btoa(encodeStr))
        },
        decodeReportHash(hash) {
            let reportID = "number" === typeof hash ? hash : null
            let companyID = null
            let decodeStr = "number" === typeof hash ? null : atob(atob(hash))
            let replaceStr = ":report-id"

			if( decodeStr ) {
				if (decodeStr.includes(":company-")) {
					replaceStr = decodeStr.slice(decodeStr.indexOf(":"))

					companyID = parseInt(decodeStr.slice(decodeStr.indexOf("-") + 1))
				}

				reportID = parseInt(decodeStr.replace(replaceStr, ""))
			}

            return {
                reportID: reportID,
                companyID: companyID,
            }
        },
        async getAllMembers(companyId = null) {
            const rs = await this.memberSvc.list(
                {
                    company_id: companyId,
                },
                false
            )

            this.members = rs.data.data.data.members.results
        },
        async assignToAllMembers(reportIds = null, companyId = null) {
            this.$emitter.emit("assign-report-access", {
                status: true,
                assignee: "all-members",
            })

            await this.getAllMembers(companyId)

            await this.reportSvc.assignAccess(
                {
                    report_list: reportIds,
                    member_list: this.memberIds,
                    company_id: companyId,
                },
                true,
                false
            )

            this.$emitter.emit("assign-report-access", false)
        },
    },
}
